<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lsQgR5/tc-custom/9781452124407.jpg?1706909649575" alt="This image is the cover for the book Hand-Crafted Candy Bars"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hand-Crafted Candy Bars
      </h1>
      <p class="bookDescription body article font2">
        <b>“Chocolate peanut butter cups and candy bars are transformed into elegant, sophisticated sweets using the finest chocolate and freshest ingredients.” —<i>The San Diego Union-Tribune</i></b><br/><br/>The beloved candy bars of childhood have grown up, but there is no need to go to the French Laundry to get your fix. Candy bar devotees Susie Norris and Susan Heeger show how to reinvent candy bars as they should be—thick and layered with nougat, crisp with toffee, and coated with fine chocolate. Familiar candy-store bars and other nostalgic favorites are re-created using the freshest ingredients, right down to the peanut-laden caramel and chocolate-drenched cookie crunch. A mix-and-match flavor chart inspires anyone with a sweet tooth to dream up custom treats of their own, such as covering marshmallows with molten chocolate. From the basics of candy making to tips on dressing up these luscious indulgences as elegant desserts, <i>Hand-Crafted Candy Bars</i> evokes the sweet memory of youth with simple, scrumptious sophistication.<br/><br/><b>“Recipes for everything from Molten Chocolate-Peanut Bars, a Snickers taste-alike, to Candied Mint and Citrus Bark. Those sugar-crisped mint leaves look particularly Halloweenish peeking from the surface.” —<i>The Times Herald</i></b><br/><br/><b>“Incorporates their love of candy, natural ingredients and other confections with terrific recipes for the home cook. You can even create your own signature candy bar (look for their suggestions in the mix-and-match flavor chart to get started).” —<i>Dying for Chocolate</i></b><br/><br/><b>“Their book is filled with recipes for making ‘grown-up confections’ from home using high-quality fresh ingredients. Far (but not too far) cries from the dollar bars at the corner store.” —<i>Relish</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susie Norris, Susan Heeger, Joseph De Leo
      </h2>
      
      <p class="authorDescription body article">Susan Heeger is a book, magazine, and newspaper feature writer with a specialty in food, garden, design, home, and lifestyle stories. She lives in Los Angeles.Susie Norris is a Los Angeles–based author, pastry chef, and culinary school instructor. She is founder and artisan chocolatier of Happy Chocolates.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4aba3e11